import React, { Component } from 'react'

export default class ExpenseDetails extends Component {
  render() {
    return (
      <div>ExpenseDetails</div>
    )
  }
}
